import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** Dec 2025 toolkit */
export const finishYearStrongToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.FINISH_YEAR_STRONG,
  iFrameSrcUrl: '/year-end',
  micrositeUrl: 'year-end',
  title: {
    id: 'finishYearStrongToolkit.title',
    defaultMessage: 'End the year strong',
    description: 'Microsite page title',
  },
  featureFlag: 'isFinishYearStrongToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/staying-afloat-stress-management-basics',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
  ],
  page: '202512 finishyearstrong',
  trackUTMParams: {
    utm_campaign: 'finishyearstrong202512',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'finishingtheyearstrong',
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: true,
}
